import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconWrapperComponent } from './components/icon-wrapper/icon-wrapper.component';
import { NumberOfInputComponent } from '@ispm-client/modules/widgets/components/number-of-input/number-of-input.component';
import { ArrayAppenderComponent } from '@ispm-client/modules/widgets/components/array-appender/array-appender.component';
import { DynamicFormModule } from '@ispm/dynamic-form/dynamic-form.module';
import { SharedModule } from '@ispm/shared/shared.module';
import { GenericListComponent } from '@ispm/widgets/components/generic-list.component/generic-list.component';
import { LayoutEngineMenuComponent } from '@ispm/widgets/components/layout-engine-menu/layout-engine-menu.component';
import { LayoutEngineMenuItemComponent } from '@ispm/widgets/components/layout-engine-menu/layout-engine-menu-item/layout-engine-menu-item.component';
import { CopyrightComponent } from '@ispm/widgets/components/copyright.component/copyright.component';
import { NotesModule } from '../../app/notes/notes.module';
import { RichNotesWidgetComponent } from '@ispm/widgets/components/rich-notes-widget/rich-notes-widget.component';
import { PlaceholderWidgetComponent } from '@ispm/widgets/components/placeholder-widget/placeholder-widget.component';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RelatedEntitiesComponent } from './components/related-entities/related-entities.component';
import { SelectableItemComponent } from './components/selectable-item.component/selectable-item.component';
import { UnitValueGrouperComponent } from '@ispm/widgets/components/unit-value-grouper/unit-value-grouper.component';
import { PatientDetailsComponent } from '@ispm/widgets/components/patient-details/patient-details-modal.component';
import { PasswordEditorComponent } from './components/password-editor/password-editor.component';
import { PasswordEditorDetailsComponent } from './components/password-editor/password-editor-details/password-editor-details.component';

import { FormLoaderComponent } from '@ispm/widgets/components/form-loader/form-loader.component';
import { PopupEditorCallerComponent } from '@ispm/widgets/components/popup-editor-caller/popup-editor-caller.component';
import { LayoutModule } from '@ispm/layout/layout.module';
import { AnalyticsChartsComponent } from './components/analytics-charts/analytics-charts.component';
import { SnapshotFileViewerComponent } from '@ispm/widgets/components/snapshot-file-viewer/snapshot-file-viewer.component';
import { FileModule } from '@ispm-client/modules/file-module/file.module';
import { AppConfigurationWidgetComponent } from './components/app-configuration-widget/app-configuration-widget.component';
import { JsonEditorComponent, NgJsonEditorModule } from 'ang-jsoneditor';
import { JsonEditorConfigComponent } from '@ispm/widgets/components/json-editor/json-editor.component';
import { IFUComponent } from '@ispm/widgets/components/UploadIFU/ifu-upload-details-modal.component';
import { CommonDocumentComponent} from "@ispm/widgets/components/UploadCommonDocuments/common-docs-upload-details-modal.component";

import { PrivacyNotesComponent } from '@ispm/widgets/components/UploadPrivacyNotes/privacynotes-upload-details-modal.component';
import { ReferenceResolverComponent } from './components/reference-resolver/reference-resolver.component';
import { DropdownWithTitleModule } from '@ispm/dashboard/dropdown_with_title/dropdown-with-title.module';
import { PractitionerHandlerComponent } from './components/practitioner-handler/practitioner-handler.component';
import { CheckboxValuesetList } from '@ispm/widgets/components/checkbox-valueset-list/checkbox-valueset-list.component';
import { DecryptSmtpComponent } from './components/decrypt-smtp/decrypt-smtp.component';
import { EncryptSmtpComponent } from './components/encrypt-smtp/encrypt-smtp.component';
import { UserModule } from '@ispm/user/user.module';
import { AuthorizationComposerComponent } from './components/authorization-composer/authorization-composer.component';
import { CoreModule } from '@ispm/core/core.module';
import { ManagingFacilityComponent } from './components/managing-facility/managing-facility.component';
import { UploadReportTemplateComponent } from './components/upload-report-template/upload-report-template.component';
import { ReplaceReportTemplateComponent } from './components/replace-report-template/replace-report-template.component';
import { CheckboxSimpleGroupComponent } from './components/checkbox-simple-group/checkbox-simple-group.component';
import { CheckBoxModule as DLSCheckboxModule } from '@wuitk/angular/components/checkbox';
import { DecisionTreeCaptureComponent } from './components/decision-tree-capture/decision-tree-capture.component';
import { MDTDecisionTreeService } from './components/decision-tree-capture/services/mdt-decision-tree.service';
import { AppConfigGeneralInfoComponent } from './components/app-config-general-info-tab-widget/app-config-general-info-tab-widget.component';
import { CryptoService } from '@ispm/migration/services/crypto.service';
import { QuestionnairesComponent } from './components/questionnaires/questionnaires.component';
import { QuestionnairesService } from './components/questionnaires/services/questionnaire.service';
import { ManagingOrganizationFacilityComponent } from './components/managing-organization-facility/managing-organization-facility.component';
import { FactorBasedFormComponent } from './components/factor-based-form/factor-based-form.component';
import { LinkReportTemplateComponent } from '@ispm/widgets/components/attach-report-template-to-test/attach-report-template-to-test.component';
import { CloneReportTemplateComponent } from '@ispm/widgets/components/clone-report-template/clone-report-template.component';
import { DynamicContextFormComponent } from './components/dynamic-context-form/dynamic-context-form.component';
import {
  IFrameContainerWidgetComponent
} from "@ispm/widgets/components/iframe-container-widget/iframe-container-widget.component";

@NgModule({
  imports: [
    AutoCompleteModule,
    DropdownModule,
    CommonModule,
    MatSelectModule,
    MatIconModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    NotesModule,
    LayoutModule,
    FileModule,
    NgJsonEditorModule,
    DropdownWithTitleModule,
    UserModule,
    CoreModule,
    DLSCheckboxModule
  ],
  declarations: [
    IconWrapperComponent,
    NumberOfInputComponent,
    ArrayAppenderComponent,
    RelatedEntitiesComponent,
    GenericListComponent,
    CopyrightComponent,
    RichNotesWidgetComponent,
    PlaceholderWidgetComponent,
    SelectableItemComponent,
    LayoutEngineMenuComponent,
    LayoutEngineMenuItemComponent,
    UnitValueGrouperComponent,
    PatientDetailsComponent,
    DecisionTreeCaptureComponent,
    PasswordEditorComponent,
    PasswordEditorDetailsComponent,
    PopupEditorCallerComponent,
    FormLoaderComponent,
    SnapshotFileViewerComponent,
    JsonEditorConfigComponent,
    IFUComponent,
    CommonDocumentComponent,
    PrivacyNotesComponent,
    AnalyticsChartsComponent,
    SnapshotFileViewerComponent,
    AppConfigurationWidgetComponent,
    JsonEditorConfigComponent,
    ReferenceResolverComponent,
    PractitionerHandlerComponent,
    CheckboxValuesetList,
    AuthorizationComposerComponent,
    DecryptSmtpComponent,
    EncryptSmtpComponent,
    ManagingFacilityComponent,
    UploadReportTemplateComponent,
    ReplaceReportTemplateComponent,
    CheckboxSimpleGroupComponent,
    AppConfigGeneralInfoComponent,
    QuestionnairesComponent,
    ManagingOrganizationFacilityComponent,
    FactorBasedFormComponent,
    LinkReportTemplateComponent,
    CloneReportTemplateComponent,
    DynamicContextFormComponent,
    IFrameContainerWidgetComponent,
  ],
  exports: [
    IconWrapperComponent,
    NumberOfInputComponent,
    GenericListComponent,
    CopyrightComponent,
    RichNotesWidgetComponent,
    PlaceholderWidgetComponent,
    SelectableItemComponent,
    LayoutEngineMenuComponent,
    UnitValueGrouperComponent,
    DecisionTreeCaptureComponent,
    PatientDetailsComponent,
    LayoutEngineMenuItemComponent,
    PopupEditorCallerComponent,
    FormLoaderComponent,
    AnalyticsChartsComponent,
    SnapshotFileViewerComponent,
    AppConfigurationWidgetComponent,
    JsonEditorComponent,
    JsonEditorConfigComponent,
    IFUComponent,
    CommonDocumentComponent,
    PrivacyNotesComponent,
    JsonEditorConfigComponent,
    ReferenceResolverComponent,
    PractitionerHandlerComponent,
    CheckboxValuesetList,
    AuthorizationComposerComponent,
    DecryptSmtpComponent,
    EncryptSmtpComponent,
    ManagingFacilityComponent,
    UploadReportTemplateComponent,
    ReplaceReportTemplateComponent,
    AppConfigGeneralInfoComponent,
    QuestionnairesComponent,
    ManagingOrganizationFacilityComponent,
    FactorBasedFormComponent,
    LinkReportTemplateComponent,
    CloneReportTemplateComponent,
    DynamicContextFormComponent,
    IFrameContainerWidgetComponent,
  ],
  providers: [
    MDTDecisionTreeService, CryptoService, QuestionnairesService
   /*  {
      provide: 'CryptoService',
      useFactory: injectCryptoProvider,
      deps: ['$injector']
    } */
  ]
})

export class WidgetsModule {
}
